export default __webpack_public_path__ + "static/media/DarkBlue0007.01f1b8d0.png";